import { $, $$ } from '@3pc/dom';
import { ClickRedirect } from '@3pc/click-redirect';

const teaserGrids = $$('.teaser-grid__wrapper');

if (teaserGrids.length) {
  teaserGrids.forEach(teaserGrid => {
    // Get references to the source and target elements
    const sourceElement = $('.teaser-grid__item', teaserGrid);
    const targetElement = $('.teaser-grid__link', teaserGrid);

    // Define configuration options
    const config = {
      preventDefault: false, // Prevent the default click behavior
    };

    // Create a ClickRedirect instance
    const clickRedirect = new ClickRedirect(
      sourceElement,
      targetElement,
      config
    );

    // Activate the ClickRedirect (add event listeners)
    clickRedirect.activate();
  });
}
